<template>
  <router-view />
</template>

<script>
export default {
  mounted () {
    console.log('trx View');
  },
}
</script>

<style scoped>

</style>
